import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ControlledTags from '@/components/form/controlled-tags';
import { CARRIER_SIZES, CARRIER_TYPES } from '@/lib/constants';

const DIGITAL_FORMATS = ['digital', 'video'];

function CommunicationCarrier() {
  const { t } = useTranslation();
  const {
    formState,
    formState: { errors },
    watch,
    setValue,
    getFieldState,
  } = useFormContext();

  const carrierTypes = CARRIER_TYPES.map(({ value }) => ({
    value,
    i18nKey: `label.carrierTypes.${value}`,
  }));

  const carrierSizes = CARRIER_SIZES.map(({ value }) => ({
    value,
    i18nKey: `label.carrierSizes.${value}`,
  }));

  const onlyOnlineUsage = watch('onlyOnlineUsage');
  const { isTouched: hasOnlineUsageChanged } = getFieldState(
    'onlyOnlineUsage',
    formState
  );

  useEffect(() => {
    if (onlyOnlineUsage) {
      setValue('carrier.type', [{ value: 'digital' }]);
      setValue('carrier.size', [{ value: 'na' }]);
    } else if (hasOnlineUsageChanged) {
      setValue('carrier.type', []);
      setValue('carrier.size', []);
    }
  }, [onlyOnlineUsage]);

  const carrierType = watch('carrier.type');
  const { isDirty: isCarrierTypeDirty } = getFieldState(
    'carrier.type',
    formState
  );
  useEffect(() => {
    if (!isCarrierTypeDirty || !carrierType || carrierType.length === 0) {
      return;
    }
    const isDigital = carrierType.every(({ value }: { value: string }) =>
      DIGITAL_FORMATS.includes(value)
    );

    if (isDigital) {
      setValue('carrier.size', [{ value: 'na' }]);
    }
  }, [carrierType]);

  return (
    <>
      <p className="leading-normal font-bold my-4">
        {t('label.communicationCarrier')}
      </p>
      <ControlledTags
        label={t('label.type')}
        name={'carrier.type'}
        errors={errors}
        options={carrierTypes}
        multiple={true}
        readOnly={onlyOnlineUsage}
      />
      <ControlledTags
        label={t('label.size')}
        name={'carrier.size'}
        errors={errors}
        options={carrierSizes}
        multiple={true}
        readOnly={onlyOnlineUsage}
      />
    </>
  );
}

export default CommunicationCarrier;
